/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Link_Copied_To_ClipboardInputs */

const en_link_copied_to_clipboard = /** @type {(inputs: Link_Copied_To_ClipboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Link copied to clipboard`)
};

const es_link_copied_to_clipboard = /** @type {(inputs: Link_Copied_To_ClipboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enlace copiado al portapapeles`)
};

const fr_link_copied_to_clipboard = /** @type {(inputs: Link_Copied_To_ClipboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lien copié dans le presse-papiers`)
};

const de_link_copied_to_clipboard = /** @type {(inputs: Link_Copied_To_ClipboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Link in die Zwischenablage kopiert`)
};

const ja_link_copied_to_clipboard = /** @type {(inputs: Link_Copied_To_ClipboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`リンクがクリップボードにコピーされました`)
};

const zh_link_copied_to_clipboard = /** @type {(inputs: Link_Copied_To_ClipboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`链接已复制到剪贴板`)
};

const ar_link_copied_to_clipboard = /** @type {(inputs: Link_Copied_To_ClipboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تم نسخ الرابط إلى الحافظة`)
};

const id_link_copied_to_clipboard = /** @type {(inputs: Link_Copied_To_ClipboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tautan disalin ke papan klip`)
};

const it_link_copied_to_clipboard = /** @type {(inputs: Link_Copied_To_ClipboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Link copiato negli appunti`)
};

const ru_link_copied_to_clipboard = /** @type {(inputs: Link_Copied_To_ClipboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ссылка скопирована в буфер обмена`)
};

const pt_link_copied_to_clipboard = /** @type {(inputs: Link_Copied_To_ClipboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Link copiado para a área de transferência`)
};

const ko_link_copied_to_clipboard = /** @type {(inputs: Link_Copied_To_ClipboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`링크가 클립보드에 복사되었습니다`)
};

/**
* | output |
* | --- |
* | "Link copied to clipboard" |
*
* @param {Link_Copied_To_ClipboardInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const link_copied_to_clipboard = /** @type {((inputs?: Link_Copied_To_ClipboardInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Link_Copied_To_ClipboardInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_link_copied_to_clipboard(inputs)
	if (locale === "es") return es_link_copied_to_clipboard(inputs)
	if (locale === "fr") return fr_link_copied_to_clipboard(inputs)
	if (locale === "de") return de_link_copied_to_clipboard(inputs)
	if (locale === "ja") return ja_link_copied_to_clipboard(inputs)
	if (locale === "zh") return zh_link_copied_to_clipboard(inputs)
	if (locale === "ar") return ar_link_copied_to_clipboard(inputs)
	if (locale === "id") return id_link_copied_to_clipboard(inputs)
	if (locale === "it") return it_link_copied_to_clipboard(inputs)
	if (locale === "ru") return ru_link_copied_to_clipboard(inputs)
	if (locale === "pt") return pt_link_copied_to_clipboard(inputs)
	return ko_link_copied_to_clipboard(inputs)
});